import { KonakartService, MyAccountService, NavigationService } from '@sky-tv-group/shared';
import { agentKK, agentMyAccountNonLoggedIn, agentNavigation } from './agent';

export let navService = new NavigationService(agentNavigation);

export let myAccountService = new MyAccountService(agentMyAccountNonLoggedIn);
export let kkService = new KonakartService(agentKK);
